<a type="button" class="btn text-white" [href]="link">
  {{ buttonText }}
</a>
